import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
	appid: '',
	redirectURL: ''
}

export default {
	state,
	getters,
	actions,
	mutations
};